<template>
  <div class="dsf-readfilestructure" v-loading="progressFlag">
    <div class="item">
      <div class="title">
        <div class="path">
          <i class="iconfont icon-wenjianjia"></i>
          <el-input placeholder="路径" v-model="rootPath" clearable readonly></el-input>
        </div>
        <div class="btns">
          <dsf-button icon="add" style="margin-right: 10px" @click="dialogVisible = true" title="创建文件夹">新建文件夹</dsf-button>
          <!-- -->
          <el-upload
            class="upload-demo"
            :action="dsf.url.getWebPath(uploadFileUrl)"
            :file-list="fileList"
            :http-request="httpRequest"
            :on-success="handleSuccess"
            :on-error="handleError"
            :on-change="handleChange"
            :disabled="progressFlag"
          >
            <dsf-button title="上传文件" icon="shangchuan" :disabled="progressFlag">上传文件</dsf-button>
          </el-upload>
          <div v-if="showProgress" class="progress">
            <el-progress
              id="progress"
              type="circle"
              :percentage="percent"
              :stroke-width="8"
              :width="100"
              :show-text="true"
              stroke-linecap="round"
              :format="progressFormat"
            ></el-progress>
          </div>
        </div>
      </div>
      <el-table style="width: 100%" height="500" border stripe :data="tableData">
        <el-table-column width="auto" label="名称" align="left" prop="name" key="name">
          <template slot-scope="scope">
            <div @click="loadNextFile(scope.row)" :class="{ folder: scope.row.dir }">
              <i class="iconfont icon-wenjianjia" v-if="scope.row.dir"></i>
              {{ scope.row.name }}
            </div>
          </template>
        </el-table-column>
        <el-table-column width="auto" label="大小" align="left" prop="size" key="size"></el-table-column>
        <el-table-column width="auto" label="类型" align="left" prop="type" key="type"></el-table-column>
        <el-table-column width="auto" label="修改时间" align="left" prop="modifyTime" key="modifyTime"></el-table-column>
        <!-- <el-table-column width="auto" label="修改时间" align="left" prop="modifyTime" key="modifyTime"></el-table-column> -->
        <el-table-column width="auto" label="路径" align="left" prop="path" key="path"></el-table-column>
        <el-table-column width="auto" label="owner" align="left" prop="owner" key="owner"></el-table-column>
      </el-table>
    </div>
    <el-dialog :close-on-click-modal="false" title="新建文件夹" :modal="false" :visible.sync="dialogVisible" width="400px">
      <el-form :model="directory" :rules="rules" ref="directory" label-width="120px">
        <el-form-item label="文件夹名称:" prop="name">
          <el-input v-model="directory.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <dsf-button @click="confirm" title="确定">确 定</dsf-button>
        <dsf-button type="plain" @click="cancel" title="取消">取 消</dsf-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default dsf.component({
  name: "DsfReadFileStructure",
  ctrlCaption: "文件列表",
  mixins: [$mixins.control],
  props: {
    name: {
      type: String,
      default: "",
    },
    ip: {
      type: String,
      default: "",
    },
    port: {
      type: String,
      default: "",
    },
    protocolValue: {
      type: String,
      default: "",
    },
    username: {
      type: String,
      default: "",
    },
    pwd: {
      type: String,
      default: "",
    },
    pathModeValue: {
      type: String,
      default: "",
    },
    path: {
      type: String,
      default: "",
    },
    fileName: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "ftp",
    },
    resourceId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      sourceIdUrl: "/ftp/connectFtp",
      sourceFilrUrl: "/ftp/listFile",
      sourceCloseUrl: "/ftp/disConnectFtp",
      uploadFileUrl: "/ftp/uploadFile",
      createDirectoryUrl: "/ftp/createDirectory",
      sourceId: null,
      tableData: [],
      rootPath: null,
      dialogVisible: false,
      rules: {
        name: [
          { required: true, message: "请输入文件夹名称", trigger: "blur" },
          { min: 1, max: 50, message: "长度在 1 到 50 个字符", trigger: "blur" },
        ],
      },
      directory: {
        name: "",
      },
      fileList: [],
      percent: 0,
      progressFlag: false,
      deg: 135,
      status: this.percent < 100 ? "" : "success", //进度条组件加上状态后不显示文字
      color: [
        { color: "#fdfdfd", percentage: 99 },
        { color: "#ccccc", percentage: 100 },
      ],
      showProgress: false,
      _resourceId: this.resourceId,
    };
  },
  mounted() {
    if (!this.resourceId) {
      if (this.queryString) {
        this._resourceId = this.queryString.resourceId || this.queryString.resource_id;
      }
    }
    this.loadFileSource();
  },
  methods: {
    handleSuccess(file, fileList) {
      // console.log("handleSuccess", file, fileList);
    },
    handleError(files, fileList) {
      // console.log("handleError", files, fileList);
    },
    handleChange(files, fileList) {
      // console.log("handleChange", files, fileList);
    },
    httpRequest(params) {
      // console.log("file params", params);
      this.showProgress = true;
      this.progressFlag = true;
      let formData = new FormData();
      formData.append("file", params.file);
      const config = {
        headers: { "Content-Type": "multipart/form-data" },
      };
      var configa = {
        // onUploadProgress: (progressEvent) => {
        //   // progressEvent.loaded:已上传文件大小
        //   // progressEvent.total:被上传文件的总大小
        //   this.percent = Number(((progressEvent.loaded / progressEvent.total) * 90).toFixed(2));
        // },
        timeout: 0,
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: progressEvent => {
          if (progressEvent.lengthComputable) {
            this.percent = ((progressEvent.loaded / progressEvent.total) * 100) | 0;
          }
        },
      };
      var path = this.rootPath || this.path;
      this.$http
        .post("/ftp/uploadFile?type=" + this.type + "&connectId=" + this.sourceId + "&path=" + this.rootPath, formData, configa)
        .done(res => {
          if (!res.success) {
            dsf.layer.message(res.message, false);
            this.percent = -1;
            this.progressFlag = false;
            setTimeout(() => {
              this.showProgress = false;
              this.percent = 0;
            }, 1000);
          } else {
            params.onSuccess(res);
            dsf.layer.message("文件上传成功");
            //刷新列表
            this.loadFileDetail(path);
            this.progressFlag = false;
            this.percent = 100;
            setTimeout(() => {
              this.showProgress = false;
              this.percent = 0;
            }, 1000);
          }
        })
        .error(err => {
          params.onError(err);
          this.percent = -1;
          setTimeout(() => {
            this.showProgress = false;
            this.percent = 0;
          }, 1000);
        });
    },
    cancel() {
      this.directory.name = "";
      this.dialogVisible = false;
    },
    progressFormat(percentage) {
      var text = "";
      if (percentage > -1 && percentage < 100) {
        text = "已上传(" + percentage + "%)";
      } else if (percentage == 100) {
        text = "上传完成";
      } else {
        text = "上传失败";
      }
      return text;
    },
    confirm() {
      this.$refs.directory.validate(valid => {
        if (valid) {
          this.createDirectory();
        } else {
          return false;
        }
      });
    },
    createDirectory() {
      const params = {
        type: this.type,
        connectId: this.sourceId,
        name: this.directory.name,
        path: this.rootPath || this.path,
      };
      this.$http
        .post(this.createDirectoryUrl, params)
        .done(({ success, data, message }) => {
          if (success) {
            this.dialogVisible = false;
            this.directory.name = "";
            dsf.layer.message("新建文件夹成功");
            //刷新列表
            this.loadFileDetail(this.rootPath);
          } else {
            dsf.layer.message(message || "请求异常", false);
          }
        })
        .error(err => {
          dsf.error(err);
          dsf.layer.message(err.message || "请求异常", false);
          reject(false);
        });
    },
    loadNextFile(it) {
      const { dir, path } = it;
      if (dir) {
        this.loadFileDetail(path);
      }
    },
    async loadFileSource() {
      if (this.type == "ftp") {
        let res = await this.loadFileSourceId();
        if (res) {
          this.loadFileDetail();
        }
      } else {
        this.loadFileDetail();
      }
    },
    loadFileDetail(path) {
      const params = {
        resourceId: this._resourceId,
        path: path || this.path,
        type: this.type,
      };
      if (this.type == "ftp") {
        params.connectId = this.sourceId;
      }
      this.$http
        .get(this.sourceFilrUrl, params)
        .done(({ success, data, message }) => {
          if (success) {
            if (data && data.length) {
              this.tableData = data;
              // this.rootPath = data.length === 0 ? null : data[0].path;
              this.rootPath = path ? path : this.path;
              this.uploadFileUrl = "/ftp/uploadFile?type=" + this.type + "&connectId=" + this.sourceId + "&path=" + this.rootPath;
            }
            // console.log(data);
          } else {
            dsf.layer.message(message || "请求异常", false);
          }
        })
        .error(err => {
          dsf.error(err);
          dsf.layer.message(err.message || "请求异常", false);
        });
    },
    loadFileSourceId() {
      return new Promise((resolve, reject) => {
        /**
         * @params ip 地址
         * @params port 端口
         * @params protocolValue 协议值 ftp 1 sftp 0
         * @params username 用户名
         * @params pwd 密码
         * @params pathModeValue
         * @params path
         * @params fileName
         *
         */
        const params = {
          ip: this.ip,
          port: this.port,
          protocolValue: this.protocolValue,
          username: this.username,
          pwd: this.pwd,
        };
        this.$http
          .post(this.sourceIdUrl, params)
          .done(({ success, data, message }) => {
            if (success) {
              this.sourceId = data;
              this.uploadFileUrl = "/ftp/uploadFile?type=" + this.type + "&connectId=" + this.sourceId + "&path=" + this.rootPath || this.path;
              resolve(data);
            } else {
              dsf.layer.message(message || "请求异常", false);
              reject(false);
            }
          })
          .error(err => {
            dsf.error(err);
            dsf.layer.message(err.message || "请求异常", false);
            reject(false);
          });
      });
    },
    closeSourceFtp() {
      return new Promise((resolve, reject) => {
        const params = {
          connectId: this.sourceId,
        };
        this.$http
          .post(this.sourceCloseUrl, params)
          .done(({ success, message }) => {
            if (success) {
              resolve(true);
            } else {
              dsf.layer.message(message || "请求异常", false);
              reject(false);
            }
          })
          .error(err => {
            dsf.layer.message(err.message || "请求异常", false);
            reject(false);
          });
      });
    },
    async yes() {
      const res = await this.closeSourceFtp();
      return res;
    },
  },
});
</script>
